import { createAction } from '@reduxjs/toolkit';

export const clearPatchOrderedParts = createAction('clearPatchOrderedParts');
export const clearDeleteOrderedParts = createAction('clearDeleteOrderedParts');
export const setOrderedParts = createAction('setOrderedParts');
export const removeOrderedPart = createAction('removeOrderedPart');
